import { DocumentNode, gql } from '@apollo/client'

export const CREATE_MOCK_CHILD: DocumentNode = gql`
    mutation CreateMockChild(
        $firstname: String!
        $birthdate: Date!
        $preRegistrationBelgium: String
        $daycareId: Int!
    ) {
        createMockChild(
            firstname: $firstname
            birthdate: $birthdate
            preRegistrationBelgium: $preRegistrationBelgium
            daycareId: $daycareId
        )
    }
`

export const UPDATE_MOCK_CHILD: DocumentNode = gql`
    mutation UpdateMockChild(
        $childId: Int!
        $firstname: String!
        $birthdate: Date!
        $preRegistrationBelgium: String
        $daycareId: Int!
    ) {
        updateMockChild(
            childId: $childId
            firstname: $firstname
            birthdate: $birthdate
            preRegistrationBelgium: $preRegistrationBelgium
            daycareId: $daycareId
        )
    }
`
